module.exports = __webpack_public_path__ + "static/img/dzsp.fa315ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/businessTicketDiscount/dzsp.png
// module id = Sy79
// module chunks = 69